import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function checkSsnFormatValidity(ssn: string): Promise<string | undefined> {
  return restApiClient
    .url(constructApiUrl(API.candidate.checkSsnFormatValidity.url, null))
    .post<string | undefined>({ ssn })
}
